const problems = [
  {
    icon: 'ri-time-line',
    title: 'Слабый оффер',
    text: 'Посетитель за 3 секунды не понимает, чем вы лучше конкурентов.',
  },
  {
    icon: 'ri-computer-line',
    title: 'Технические барьеры',
    text: 'Сайт долго грузится или «криво» отображается на телефоне.',
  },
  {
    icon: 'ri-route-line',
    title: 'Сложный путь',
    text: 'Лишние поля в формах и запутанная навигация «убивают» желание оставить заявку.',
  },
  {
    icon: 'ri-git-branch-line',
    title: 'Разрыв логики',
    text: 'Вы предлагаете купить «в лоб» тем, кто ещё только изучает проблему.',
  },
];

export default function AuditProblem() {
  return (
    <section className="py-16 md:py-24 bg-[#1A2B4C] relative overflow-hidden">
      {/* Decorative rings — hidden on mobile */}
      <div className="hidden md:block absolute top-0 right-0 w-96 h-96 border border-[#C5A880]/10 rounded-full translate-x-1/3 -translate-y-1/3"></div>
      <div className="hidden md:block absolute bottom-0 left-0 w-72 h-72 border border-[#C5A880]/10 rounded-full -translate-x-1/3 translate-y-1/3"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        {/* Header */}
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-[#C5A880]/15 border border-[#C5A880]/30 rounded-full px-4 sm:px-5 py-2 mb-5 md:mb-6">
            <i className="ri-alert-line text-[#C5A880] text-sm"></i>
            <span className="text-[#C5A880] text-xs sm:text-sm font-semibold font-['Montserrat'] uppercase tracking-widest">Диагностика проблем</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-5 md:mb-6 font-['Playfair_Display'] leading-tight">
            Ваш сайт — пассивный актив или<br className="hidden sm:block" />
            <span className="text-[#C5A880]"> работающая система продаж?</span>
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-white/70 max-w-3xl mx-auto leading-relaxed font-['Montserrat'] text-justify">
            Большинство сайтов недополучают до <strong className="text-[#C5A880]">70% прибыли</strong> из-за невидимых ошибок в логике и юзабилити.
          </p>
        </div>

        {/* Key message */}
        <div className="bg-white/5 border-l-4 border-[#C5A880] rounded-2xl p-5 sm:p-8 mb-10 md:mb-14 max-w-4xl mx-auto">
          <p className="text-base sm:text-lg text-white/85 leading-relaxed font-['Montserrat'] mb-4 text-justify">
            Если реклама идёт, а заявок нет — <strong className="text-white">проблема не в трафике.</strong> Вашему сайту нужна глубокая диагностика смыслов.
          </p>
          <p className="text-white/70 leading-relaxed font-['Montserrat'] text-sm sm:text-base text-justify">
            Многие предприниматели годами вкладывают деньги в рекламу, не понимая, что их сайт — это «дырявое ведро». Клиент заходит, но не покупает.
          </p>
        </div>

        {/* Problems grid */}
        <div className="mb-8 md:mb-10">
          <p className="text-center text-[#C5A880] font-semibold font-['Montserrat'] text-xs sm:text-sm uppercase tracking-widest mb-6 md:mb-8">
            Основные причины «слива» бюджета:
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
            {problems.map((item, i) => (
              <div
                key={i}
                className="bg-white/5 hover:bg-white/10 border border-[#C5A880]/20 hover:border-[#C5A880]/50 rounded-2xl p-5 sm:p-6 transition-all duration-300 group"
              >
                <div className="flex items-center justify-center w-12 h-12 bg-[#C5A880]/20 group-hover:bg-[#C5A880] rounded-xl mb-4 transition-all duration-300">
                  <i className={`${item.icon} text-[#C5A880] group-hover:text-white text-xl transition-colors duration-300`}></i>
                </div>
                <h3 className="text-white font-bold text-base mb-2 font-['Playfair_Display']">{item.title}</h3>
                <p className="text-white/60 text-sm leading-relaxed font-['Montserrat'] text-justify">{item.text}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom stat */}
        <div className="text-center">
          <div className="inline-flex items-center gap-3 sm:gap-4 bg-[#C5A880]/10 border border-[#C5A880]/30 rounded-2xl px-5 sm:px-8 py-4 sm:py-5">
            <div className="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 flex-shrink-0">
              <i className="ri-bar-chart-grouped-line text-[#C5A880] text-2xl sm:text-3xl"></i>
            </div>
            <p className="text-white/80 font-['Montserrat'] text-sm md:text-base text-left">
              <strong className="text-[#C5A880]">Профессиональный аудит</strong> выявляет неочевидные ошибки
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
